//文字コードはutf-8

import { updateBodyHeight } from './tabletScale.js';

export function headerScrolling() {
  const target = document.querySelector('.jsHamburgerMenuTarget');
  if (!target) return;

  let rafId = null;
  let pageWrapper = null;
  let isTabletMode = false;

  const isTabletMediaQuery = window.matchMedia('(min-width: 769px) and (max-width: 1160px)');
  let isTablet = isTabletMediaQuery.matches;

  // タブレットモードの初期化：pageWrapperを作成してヘッダー以外を囲む
  const initTabletMode = () => {
    if (isTabletMode) return;
    
    // ヘッダー要素を取得
    const headerElement = target.tagName === 'HEADER' ? target : target.closest('.header');
    if (!headerElement) return;
    
    // 既にpageWrapperが存在する場合はスキップ
    if (document.querySelector('.pageWrapper')) {
      pageWrapper = document.querySelector('.pageWrapper');
      isTabletMode = true;
      return;
    }
    
    // pageWrapperを作成
    pageWrapper = document.createElement('div');
    pageWrapper.className = 'pageWrapper';
    
    // bodyの直下の要素を取得
    const bodyChildren = Array.from(document.body.children);
    
    // ヘッダー以外の要素をpageWrapperに移動
    bodyChildren.forEach((child) => {
      if (child !== headerElement && !child.classList.contains('pageWrapper')) {
        pageWrapper.appendChild(child);
      }
    });
    
    // pageWrapperをbodyの直下、ヘッダーの後に追加
    if (headerElement.nextSibling) {
      headerElement.parentNode.insertBefore(pageWrapper, headerElement.nextSibling);
    } else {
      document.body.appendChild(pageWrapper);
    }
    
    isTabletMode = true;
    
    // pageWrapper作成後にbodyの高さを調整
    updateBodyHeight();
  };

  // タブレットモードの解除：pageWrapperを削除して元の構造に戻す
  const exitTabletMode = () => {
    if (!isTabletMode || !pageWrapper) return;
    
    // pageWrapper内の要素をbodyに戻す
    const wrapperChildren = Array.from(pageWrapper.children);
    const headerElement = target.tagName === 'HEADER' ? target : target.closest('.header');
    
    if (headerElement) {
      // ヘッダーの後に要素を挿入
      // 順序を保持するために、逆順に処理する必要がある
      // （insertBeforeを使うと、nextSiblingが変わるため）
      for (let i = wrapperChildren.length - 1; i >= 0; i--) {
        const child = wrapperChildren[i];
        if (headerElement.nextSibling) {
          headerElement.parentNode.insertBefore(child, headerElement.nextSibling);
        } else {
          document.body.appendChild(child);
        }
      }
    } else {
      // ヘッダーが見つからない場合は、bodyの最後に追加（順序を保持するため逆順）
      for (let i = wrapperChildren.length - 1; i >= 0; i--) {
        document.body.appendChild(wrapperChildren[i]);
      }
    }
    
    // pageWrapperを削除
    pageWrapper.remove();
    pageWrapper = null;
    isTabletMode = false;
    
    // bodyの高さをリセット（タブレット以外に切り替えた時）
    document.body.style.height = '';
    document.body.classList.remove('is-tablet');
  };

  const updateHeaderPosition = () => {
    const scrollTop = window.scrollY || window.pageYOffset || 0;
    const targetHeight = target.offsetHeight;

    // is-scrollingクラスの管理
    if (scrollTop > targetHeight) {
      target.classList.add('is-scrolling');
    } else {
      target.classList.remove('is-scrolling');
    }

    rafId = null;
  };

  const handleScroll = () => {
    // requestAnimationFrameで最適化
    if (!rafId) {
      rafId = requestAnimationFrame(updateHeaderPosition);
    }
  };

  // メディアクエリの変化を監視
  const handleMediaQueryChange = (e) => {
    isTablet = e.matches;
    
    if (isTablet) {
      initTabletMode();
    } else {
      exitTabletMode();
    }
    
    // スクロール位置の更新
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    updateHeaderPosition();
  };

  if (isTabletMediaQuery.addEventListener) {
    isTabletMediaQuery.addEventListener('change', handleMediaQueryChange);
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // 初回実行
  if (isTablet) {
    initTabletMode();
  }
  updateHeaderPosition();
}
